// Small Lucide icon that flags whether a row is a Deliverable or an
// Obligation. The Type column has been dropped,
// so the kind distinction rides next to the row name at 14px. The
// icon is semantic — `aria-label` carries the Type value for screen
// readers. Sizing matches the EvidenceIndicator Paperclip at w-3.5
// h-3.5 so the row's icon stack reads at a consistent rhythm.

import { ClipboardCheck, Scale } from "lucide-react";
import type { DeliverableType } from "../../../../types";

export interface DeliverableKindIconProps {
  deliverableType: DeliverableType;
}

const LABELS: Record<DeliverableType, string> = {
  deliverable: "Deliverable",
  obligation: "Obligation",
};

export default function DeliverableKindIcon({
  deliverableType,
}: DeliverableKindIconProps) {
  const Icon = deliverableType === "obligation" ? Scale : ClipboardCheck;
  return (
    <Icon
      aria-label={LABELS[deliverableType]}
      className="w-3.5 h-3.5 text-slate-500 dark:text-slate-400"
    />
  );
}
